<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<el-row>
						<el-col :span="24">
							<button class="selectAll" @click="goback" style="margin: 0 0 30px 0;">返回</button>
							<button class="selectAll" @click="add('add',formId)" style="margin: 0 0 30px 0;">添加描述</button>
							<el-table   :default-sort = "{prop: 'id',prop:'order', order: 'descending'}" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
							 element-loading-background="rgba(0, 0, 0, 0.8)" size="mini" ref="multipleTable" :data="tableData" style="width: 100%"
							 border :header-cell-style="{background:'#E5E7EE',color:'#000000'}" row-key="id"  :tree-props="{children: 'childRpColum', hasChildren: 'hasChildren'}"
							 @select-all="selectAll"   >
							 	<el-table-column prop="id" label="编号" align="center "  sortable>
								</el-table-column>
								<el-table-column prop="order" label="排序" align="center" sortable>
								</el-table-column>
								<el-table-column align="center" :prop="dropCol[index].prop" :label="item.label"
									v-for="(item,index) in col" :key="`col_${index}`">
								</el-table-column>
								<el-table-column prop="createTime" label="创建时间" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.createTime.split(' ')[0]}}</span>
										<br />
										<span>{{scope.row.createTime.split(' ')[1]}}</span>
									</template>
								</el-table-column>
								<el-table-column prop="updateTime" label="更新时间" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.updateTime.split(' ')[0]}}</span>
										<br />
										<span>{{scope.row.updateTime.split(' ')[1]}}</span>
									</template>
								</el-table-column>
								<el-table-column fixed="right" label="更多操作">
									<template slot-scope="scope">
										<el-button type="success" icon="el-icon-edit" circle  size="small" @click="add('update',scope.row)"></el-button>
										<!-- <el-button type="success" icon="el-icon-edit" circle  size="small"  @click.native.prevent="update('update',scope.row)"></el-button> -->
										<el-button type="danger" icon="el-icon-delete" circle  @click="deleteRow(scope.row)"  size="small"></el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>

				</el-card>
			</el-col>
		</el-row>
		
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	
    import Editor from "@/components/tinymce";
	// import EditorBar from '../../../components/editor.vue'
	export default {
		components: {
			Editor
		},
		data() {
			return {
				desId:'',
				desDialog: {
					describe:''
				},
				rules:{
					describe:[
						{required:true,message:'请输入描述',tigger:'blur'}
					]
				},
				title: '添加子栏目',
				tableData: [],
				currentPage: 1,
				pageSize: 5,
				total: 0,
				isAllSelect: false,
				dialogVisible: false,
				types: '',
				// 添加或修改
				addType: '',
				columnId: '',
				typesId: '',
				loading: false,

                formId:'',
                col: [
					{
						label: '表单id',
						prop: 'formId'
					},
					{
						label: '表单名称',
						prop: 'formName'
					},
					{
						label: '描述',
						prop: 'describe'
					}, 
				],
				dropCol: [
					{
						label: '表单id',
						prop: 'formId'
					},
					{
						label: '表单名称',
						prop: 'formName'
					},
					{
						label: '描述',
						prop: 'describe'
					},
				],
               
			}
		},
		created() {
            this.formId = this.$route.query.iden
			this.getData()
		},
		methods: {
			//获取列表数据
			getData() {
				this.loading = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: '/api/v1/form/describe/page',
					params: {
                        formId:this.formId,
						pageNum: this.currentPage,
						pageSize: this.pageSize,
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.loading = false
						console.log(res,'描述列表')
						this.tableData = res.data.data.data
						this.total = res.data.data.total
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//添加一级栏目
			add(type, rows) {
				this.addType = type
				if (type == 0) {
					// this.dialogVisible = true
					this.$router.push({
						path:'/home/desUpdate',
						query:{
							rows: rows,
							iden: type
						}
					})
				} else {
					this.$router.push({
						path:'/home/desUpdate',
						query:{
							rows: rows,
							iden: type
						}
					})
					// this.desId = rows.id
					// this.desDialog.describe = rows.describe
					// this.dialogVisible = true
				}
			},
			// Onsubmit(formName) {
			// 	if(this.addType==0){
			// 		this.$refs[formName].validate((valid) => {
			// 	          if (valid) {
			// 	           var obj = this;
			// 	           obj.$http({
			// 	           	method: 'post',
			// 	           	url: '/api/v1/form/describe/add',
			// 	           	data: {
			// 	           		formId:this.formId,
			// 					describe:this.desDialog.describe
			// 	           	},
			// 	           }).then((res) => {
			// 	           	if (res.status == 200) {
			// 	           		this.dialogVisible = false
			// 	           		this.getData()
			// 	           		this.addType = ''
			// 					this.desDialog.describe = ''
				           		
			// 	           	} else {
			// 	           		obj.$message.error(res.message)
			// 	           	}
			// 	           })
			// 	          } else {
			// 	            console.log('error submit!!');
			// 	            return false;
			// 	          }
			// 	        });
			// 	}
			// 	else{
			// 		this.onUpdate(formName)
			// 	}
				 
				
			// },
			// onUpdate(formName) {
			// 	this.$refs[formName].validate((valid) => {
			// 	          if (valid) {
			// 	           var obj = this;
			// 	           obj.$http({
			// 	           	method: 'post',
			// 	           	url: '/api/v1/form/describe/update',
			// 	           	data: {
			// 	           		id:this.desId,
			// 					describe:this.desDialog.describe
			// 	           	},
			// 	           }).then((res) => {
			// 	           	if (res.status == 200) {
			// 	           		this.dialogVisible = false
			// 	           		this.getData()
			// 	           		this.addType = ''
			// 					this.desDialog.describe = ''
				           		
			// 	           	} else {
			// 	           		obj.$message.error(res.message)
			// 	           	}
			// 	           })
			// 	          } else {
			// 	            console.log('error submit!!');
			// 	            return false;
			// 	          }
			// 	        });
			// },
			
			deleteRow(rows) {
				console.log(rows)
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					var obj = this;
					obj.$http({
						method: 'get',
						url: '/api/v1/form/describe/delete/'+rows.id,
					}).then((res) => {
						if (res.status == 200) {
							obj.$message.success('删除成功')
							this.getData()
						} else {
							obj.$message.error(res.data.message)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			//分页事件
			handleSizeChange(val) {
				this.pageSize = val; //将每页显示的条数 = 改变的值
				this.getData(this.currentPage, this.pageSize)
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData(this.currentPage, this.pageSize)
			},
			// 全选/取消选操作
			selectAll(selection, first) {
				if (!first) {
					this.isAllSelect = !this.isAllSelect;
				}
				selection.map(el => {
					if (el.children) {
						el.children.map(j => {
							this.toggleSelection(j, this.isAllSelect);
						});
						if (el.children.length > 0) {
							this.selectAll(el.children, true);
						}
					}
				});
			},
			//全选
			toggleSelection(row, select) {
				if (select) {
					this.$refs.multipleTable.toggleRowSelection(row, select);
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			//批量删除
			del() {
				if (this.$refs.multipleTable.selection.length == 0) {
					this.$message.error('请选择要删除的表格信息！');
					return;
				}
				
			},
			handleClose(done) {
				done();
			},
			goback(){
				this.$router.push({
					path: '/home/formManage',
				})
			}
		},
	}
</script>

<style scoped="scoped">
	.selectAll{
		float: none;
	}
	/deep/ .el-input__inner {
		height: 40px !important;
	}

	/deep/ .el-textarea__inner {
		height: 150px !important;
	}

	/deep/ .el-form-item__label {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #000000;
		line-height: 24px;
	}

	/deep/ .el-button--text {
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}
	
	span ,/deep/ .el-table .cell{
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		/* line-height: 24px; */
	}

	.chenggong {
		width: 49px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.7;
	}

	.fail {
		width: 33px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #76B67E;
		line-height: 24px;
	}

	/deep/ .el-message {
		z-index: 9999999999999;
	}
	/deep/ .el-table__row--level-0,/deep/ .expanded{
		/* background-color: #fdf5e6; */
	}
	/deep/ .el-table__row--level-1{
		background-color:#f0f9eb;
	}
/deep/ .el-table__row--level-2{
		background-color:#fdf5e6;
	}
	.addColumn{
	background-color: #7C96F8;
	color: #FFFFFF;
	border: 1px solid #7C96F8;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/form/desAdd.vue